/* eslint-disable react/jsx-props-no-spreading */
import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Video, Transformation } from "cloudinary-react";
import * as styles from "./VideoPlayer.module.scss";

const defaultTransformations = {
	quality: "auto",
	fetchFormat: "auto",
};

const cx = classNames;
const CNVideoPlayer = ({
	style,
	className,
	cloudName,
	publicId,
	lang,
	setPlayer,
	posterUrl,
	transformations: providedTransformations,
	...props
}) => {
	const transformations = {
		...defaultTransformations,
		...providedTransformations,
	};
	const ref = useRef();
	useEffect(() => {
		if (setPlayer) setPlayer(ref.current);
	}, [ref, setPlayer]);
	return (
		<div className={cx(className)} style={style} lang={lang}>
			<Video
				className={cx(styles.player)}
				cloudName={cloudName}
				controls
				publicId={publicId}
				innerRef={ref}
				secure
				poster={posterUrl}
				{...props}>
				<Transformation {...transformations} />
			</Video>
		</div>
	);
};

CNVideoPlayer.propTypes = {
	className: PropTypes.string,
	style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
	cloudName: PropTypes.string.isRequired,
	publicId: PropTypes.string.isRequired,
	setPlayer: PropTypes.func,
	lang: PropTypes.oneOf(["en", "fr"]),
	posterUrl: PropTypes.string,
	transformations: PropTypes.shape({
		quality: PropTypes.string,
		fetchFormat: PropTypes.string,
	}),
};
CNVideoPlayer.defaultProps = {
	className: "",
	style: {},
	lang: "en",
	setPlayer: undefined,
	posterUrl: "",
	transformations: defaultTransformations,
};

export default CNVideoPlayer;
export { CNVideoPlayer };
